<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="7" lg="5" xl="4" class="text-center">
        <v-card>
          <v-card-text>
            <v-img
              :src="require('@/assets/logo.png')"
              class="my-3"
              contain
              height="100"
            ></v-img>
            <v-form v-model="isValidForm" ref="changePForm">
              <v-row>
                <v-col cols="12" align="center">
                  <h3>Password Change</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card-title class="mt-3 py-0 px-0">Password Policy</v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0" align="start">
                  <ul>
                    <li>Must contain at least 8 characters</li>
                    <li>Must contain at least one upper case letter</li>
                    <li>Must contain at least one lower case letter</li>
                    <li>Must contain at least a number</li>
                    <li>Must contain at least one special character</li>
                  </ul>
                </v-col>
              </v-row>
              <v-row class="mt-6">
                <v-col cols="12">
                  <PasswordField
                    label="New Password"
                    :value="password"
                    :is-required="true"
                    :is-needed-to-validate="true"
                    @valueChange="(newValue) => this.password = newValue"
                  ></PasswordField>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <PasswordConfirmationField
                    label="Confirm New Password"
                    :value="passwordConfirmation"
                    :password-to-match="password"
                    @valueChange="(newValue) => this.passwordConfirmation = newValue"
                  ></PasswordConfirmationField>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    class="mt-2"
                    :disabled="!isValidForm"
                    block color="primary"
                    @click="handleResetPassword"
                  >Change Password</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { loginRoute } from '@/lib/constants/routes'
import { PasswordField, PasswordConfirmationField } from '@/components/shared/textFields/'

export default {
  components: {
    PasswordField,
    PasswordConfirmationField
  },
  data () {
    return {
      loginRoute,
      isValidForm: null,
      password: null,
      passwordConfirmation: null
    }
  },
  methods: {
    ...mapActions('authentication', [
      'changePasswordByToken',
      'validateResetPasswordToken'
    ]),
    handleResetPassword () {
      if (this.$refs.changePForm.validate()) {
        this.changePasswordByToken({ PasswordResetToken: this.$route.params.token, password: this.password }).then(() => {
          this.$router.push(this.loginRoute.url)
        })
      }
    }
  },
  created () {
    this.validateResetPasswordToken(this.$route.params.token).then(result => {
      if (!result) {
        this.$router.push(this.loginRoute.url)
      }
    })
  }
}
</script>
